var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("stepheader", { attrs: { step: _vm.step } }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "body current",
          attrs: {
            id: "wizard2-p-0",
            role: "tabpanel",
            "aria-labelledby": "wizard2-h-0",
            "aria-hidden": "false",
          },
        },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.ticket.anomalia,
                    expression: "ticket.anomalia",
                  },
                ],
                staticClass: "form-control",
                domProps: { value: _vm.ticket.anomalia },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.ticket, "anomalia", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("buttons", {
            attrs: { buttons: _vm.step.buttons },
            on: { action: _vm.fireaction },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "form-label", attrs: { for: "vatnumber" } },
      [
        _vm._v("Descrizione anomalia: "),
        _c("span", { staticClass: "tx-danger" }, [_vm._v("*")]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }